import React from "react";
import PropTypes from "prop-types";
import { getUrl } from "../../lib/masterUtil";
// import ReactDOM from "react-dom";
import { Dropdown, Input } from 'semantic-ui-react'

const toInt = (value) => {
  if (typeof value === "string") {
    return parseInt(value, 10);
  } else {
    return value;
  }
}

export class SearchKeywordTop extends React.Component {
  state = { value: {} };
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props);
    this.context = context;
  }
  onUpdateValue(value) {
    let newValue = Object.assign({}, this.state.value);
    for (const key in value) {
      if (value[key]) {
        newValue[key] = value[key];
      } else if (key === "keywordTarget") {
        newValue = { keywordTarget: 0 }
      }
    }
    newValue.fromTop = 1;
    this.setState({ value: newValue });
  }
  onSearch = () => {
    const url = getUrl({ condition: this.state.value });
    this.context.router.history.push(url);
  };
  onKeyDown = e => {
    if (e.keyCode === 13) {
      this.onSearch();
    }
  };
  render() {
    const options = [

      /* masterDataに入れると物件リストまで引っ張ってきちゃうのでここで定義 */
      {
        key: 0,
        text: 'すべて',
        value: 0,
      },
      {
        key: 1,
        text: '住所',
        value: 1,
      },
      {
        key: 2,
        text: '駅名',
        value: 2,
      },
      {
        key: 3,
        text: '物件名',
        value: 3,
      },
    ]
    return (
      <div className="search_keyword">
        <div className="container" style={{ overflow: "visible" }}>
          <div className="container-title">
            <img src="resource/img/title_keyword.png" className="title sphide" />
            <img src="resource/img/title_keyword_sp.png" className="title pchide" />
          </div>
          <div className="container-input">
            <Input
              type="text"
              style={{ width: "100%" }}
              placeholder="例）渋谷　"
              value={this.state.value.keyword}
              onChange={(event) => {
                this.onUpdateValue({ keyword: event.target.value });
              }}
              onKeyDown={this.onKeyDown}
              label={<Dropdown
                value={toInt(this.state.value.keywordTarget)}
                defaultValue={0}
                style={{ width: "100px" }}
                // key="0"
                options={options}
                onChange={(event, element) => {
                  this.onUpdateValue({ keywordTarget: element.value });
                }}
              />}
              labelPosition="left"
            >
            </Input>
            <button className="btn-search pchide" onClick={this.onSearch}>
              <img src="resource/img/btn_label_sp.png" />
            </button>
            <button className="btn-search sphide" onClick={this.onSearch}>
              <img src="resource/img/btn_label.png" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/top/SearchKeywordTop.jsx